import { render, staticRenderFns } from "./RemoveSupportUserModal.vue?vue&type=template&id=e705c98c&scoped=true&"
import script from "./RemoveSupportUserModal.vue?vue&type=script&lang=js&"
export * from "./RemoveSupportUserModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveSupportUserModal.vue?vue&type=style&index=0&id=e705c98c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e705c98c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e705c98c')) {
      api.createRecord('e705c98c', component.options)
    } else {
      api.reload('e705c98c', component.options)
    }
    module.hot.accept("./RemoveSupportUserModal.vue?vue&type=template&id=e705c98c&scoped=true&", function () {
      api.rerender('e705c98c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Dashboard/Layout/Modals/RemoveSupportUserModal.vue"
export default component.exports